<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TheCopyright',
  mixins: [baseMixin],
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<template>
  <div class="caption mt-10">
    ©&nbsp;{{ currentYear }} {{ $t('general.copyrightText') }}.
    <a
      v-if="$te('app.companyCookiesURL')"
      :class="[!isDarkMode ? 'grey--text' : '']"
      :href="$t('app.companyCookiesURL')"
      target="_blank"
    >
      {{ $t('general.cookiesPolicyLinkText') }},
    </a>
    &nbsp;

    <a
      v-if="$te('app.companyPrivacyURL')"
      :class="[!isDarkMode ? 'grey--text' : '']"
      :href="$t('app.companyPrivacyURL')"
      target="_blank"
    >
      {{ $t('general.privacyPolicyLinkText') }},
    </a>
    &nbsp;

    <a
      v-if="$te('app.companyTermsURL')"
      :class="[!isDarkMode ? 'grey--text' : '']"
      :href="$t('app.companyTermsURL')"
      target="_blank"
    >
      {{ $t('general.termsLinkText') }}.
    </a>
  </div>
</template>
